module.exports = __webpack_public_path__ + "static/media/front-end-libraries.4bb348a9.png";